import { useEffect } from 'react';

import { setReferralId } from './useRewardfulStore';

export const useInitReferral = () => {
  useEffect(() => {
    const initializeRewardful = () => {
      if (window.rewardful) {
        window.rewardful('ready', function () {
          if (window.Rewardful?.referral) {
            setReferralId(window.Rewardful.referral);
          } else {
            setReferralId(null);
          }
        });
      } else {
        console.error('Rewardful script not loaded');
      }
    };

    initializeRewardful();
  }, []);
};
